import React, { Component } from "react";
import { Link } from "react-router-dom";
// styles for page
import "./projects.css";
// icons for page
import Ionicon from "react-ionicons";

import Test from "../../../assets/images/logo.svg";

export default class Published extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    let list = this.props.projectList;
    return (
      <React.Fragment>
        <div className="projectMain">
          <div className="projecHeading">
            PUBLISHED {"(" + this.props.projCount + ")"}
          </div>
          <div className="projectBody">
            {list.map(item => {
              return (
                <div className="projectItem">
                  <div className="itemDate">published at {item.date}</div>
                  <div className="itemTitle">
                  <span>{item.subdomain}</span>{" "}
                    <span>
                      <Ionicon icon="ios-menu" fontSize={16} />
                    </span>
                  </div>
                  <div className="itemLogo perfectCenter">
                  <img src={Test} />
                  {/* <img src={item.logo} /> */}
                  </div>
                  <div className="absoluteItem perfectCenter">
                    <Ionicon icon="ios-paw" fontSize={26} />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </React.Fragment>
    );
  }
}
